import GenerarFechasCitas from '../views/utils/GenerarFechasCitas.vue'
import CargaArchivo from '../views/utils/CargaArchivo.vue'
import CargarArchivos from '../views/utils/CargarArchivos.vue'
import CargarArchivo from '../views/utils/CargarArchivo.vue'
import PayPal from '../views/utils/PayPal/PayPal.vue'
import PayToPlace from '../views/utils/PayToPlace/PayToPlace.vue'
import Kushki from '../views/utils/Kushki/Kushki.vue'
import Crecimiento from '../views/utils/Crecimiento.vue'
import VacunaPlan from '../views/utils/VacunaPlan.vue'
import VacunaPersTabla01 from '../views/utils/VacunaPersTabla01.vue'
import VacunaPersTabla02 from '../views/utils/VacunaPersTabla02.vue'
import VacunaPersTabla03 from '../views/utils/VacunaPersTabla03.vue'

import ActualizarClave from '../views/regLog/ActualizarClave.vue'

export default [
{
  path: '/generarfechascitas',
  name: 'GenerarFechasCitas',
  component: GenerarFechasCitas
},
{
  path: '/cargaarchivo',
  name: 'CargaArchivo',
  component: CargaArchivo
},
{
  path: '/cargararchivo',
  name: 'CargarArchivo',
  component: CargarArchivo
},
{
  path: '/cargararchivos',
  name: 'CargarArchivos',
  component: CargarArchivos
},
{
  path: '/paypal',
  name: 'PayPal',
  component: PayPal
},
{
  path: '/paytoplace',
  name: 'PayToPlace',
  component: PayToPlace
},
{
  path: '/kushki',
  name: 'Kushki',
  component: Kushki
},
{
  path: '/crecimiento',
  name: 'Crecimiento',
  component: Crecimiento,
  props: route => ({
    p_idAtencion: parseInt(route.query.p_idAtencion),
    p_idPersona: parseInt(route.query.p_idPersona),
    p_numero: parseInt(route.query.p_numero),
    p_sexo: route.query.p_sexo,
    p_EdadYears: parseInt(route.query.p_EdadYears),
    p_EdadMonths: parseInt(route.query.p_EdadMonths),
    p_EdadDays: parseInt(route.query.p_EdadDays)
  })
},
{
  path: '/vacunaplan',
  name: 'VacunaPlan',
  component: VacunaPlan
},
{
  path: '/vacunaperstabla01/:p_idpersona/:p_idatencion/:p_numero/:p_edad',
  name: 'VacunaPersTabla01',
  component: VacunaPersTabla01
},
{
  path: '/vacunaperstabla02/:p_idpersona/:p_idatencion/:p_numero/:p_edad',
  name: 'VacunaPersTabla02',
  component: VacunaPersTabla02
},
{
  path: '/vacunaperstabla03/:p_idpersona/:p_idatencion/:p_numero/:p_edad',
  name: 'VacunaPersTabla03',
  component: VacunaPersTabla03
},
{
  path: '/actualizarclave',
  name: 'ActualizarClave',
  component: ActualizarClave
},
];